import styled from 'styled-components'

export const Container = styled.div`
  margin: 0 auto;

  @media (min-width: 769px) {
    width: inherit;
  }
`
